<span class="status-chip d-inline-flex align-items-center px-2 py-1" [class]="'tone-' + tone()">{{
  label()
}}</span>
